module.exports = __webpack_public_path__ + "static/media/faqBalance-es-fr.2e3b611c.vtt";